module.exports = __webpack_public_path__ + "img/pr-2.cfdc0856.png";